import { render, staticRenderFns } from "./DeliveryAgency.vue?vue&type=template&id=672264bc&scoped=true"
import script from "./DeliveryAgency.vue?vue&type=script&lang=js"
export * from "./DeliveryAgency.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAgency.vue?vue&type=style&index=0&id=672264bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672264bc",
  null
  
)

export default component.exports